import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TalentCard from "../components/TalentCard";
import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "react-slick";

// ✅ Fixed: Added heroBg + removed trailing spaces in ALL URLs
const heroBg = "https://images.unsplash.com/photo-1504805572947-34fad45aed93";
const artist1 = "https://images.unsplash.com/photo-1487215078519-e21cc028cb29";
const artist2 = "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f";
const artist3 = "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4";

const featuredArtists = [
  { name: "Eldridge James", role: "Poet, Musician, Visionary", image: artist3, socials: ["@_eldridgejames"] },
  { name: "Stickman Tenny", role: "Hip Hop Artist", image: artist2, socials: ["@stickman_tenny"] },
  { name: "Major8ohwait", role: "Hip Hop Artist", image: artist1, socials: ["@major8ohwait"] },
];

const stats = [
  { number: "50+", label: "Talented Artists" },
  { number: "200+", label: "Successful Events" },
  { number: "15+", label: "Brand Partnerships" },
  { number: "10+", label: "Years Experience" },
];

const Home = ({ darkTheme = true }) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  const bgPrimary = darkTheme ? "#0a0a0a" : "#f5f5f5";
  const bgSecondary = darkTheme ? "#111" : "#fff";
  const textPrimary = darkTheme ? "#fff" : "#111";
  const textSecondary = darkTheme ? "#ccc" : "#555";
  const textTertiary = darkTheme ? "#aaa" : "#666";

  return (
    <div style={{ backgroundColor: darkTheme ? "#0a0a0a" : "#fff" }}>
      {/* HERO SECTION */}
      <section style={{
        position: "relative",
        backgroundImage: `url(${heroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(255,0,0,0.3) 100%)",
        }}></div>
        <div style={{
          position: "relative",
          zIndex: 1,
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 2rem",
        }}>
          <div data-aos="fade-down" style={{ maxWidth: "800px" }}>
            <h1 style={{
              fontSize: "4rem",
              fontWeight: "700",
              letterSpacing: "4px",
              marginBottom: "1.5rem",
              lineHeight: "1.1",
              color: "#fff",
            }}>FAXON ENTERTAINMENT</h1>
            <div style={{
              width: "100px",
              height: "4px",
              backgroundColor: "#ff0000",
              marginBottom: "2rem",
            }}></div>
            <p style={{
              fontSize: "1.5rem",
              fontWeight: "500",
              marginBottom: "1rem",
              color: "#fff",
            }}>
              Empowering African Artists Through Professional Management
            </p>
            <p style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              color: "#ddd",
              marginBottom: "2.5rem",
              maxWidth: "600px",
            }}>
              We specialize in artist management for AmaPiano, Hip Hop, and RnB, providing world-class
              branding, tour management, and career development opportunities.
            </p>
            <div style={{
              display: "flex",
              gap: "1.5rem",
              flexWrap: "wrap",
            }}>
              <Link to="/artists" style={{
                padding: "1rem 2.5rem",
                backgroundColor: "#ff0000",
                color: "#fff",
                borderRadius: "50px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "1rem",
                letterSpacing: "1px",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(255, 0, 0, 0.4)",
                display: "inline-block",
              }}>
                View Our Artists
              </Link>
              <Link to="/contact" style={{
                padding: "1rem 2.5rem",
                backgroundColor: "transparent",
                color: "#fff",
                border: "2px solid #fff",
                borderRadius: "50px",
                textDecoration: "none",
                fontWeight: "600",
                fontSize: "1rem",
                letterSpacing: "1px",
                transition: "all 0.3s ease",
                display: "inline-block",
              }}>
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section style={{
        padding: "4rem 2rem",
        backgroundColor: bgPrimary,
      }} data-aos="fade-up">
        <div style={{
          maxWidth: "1400px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "2rem",
        }}>
          {stats.map((stat, idx) => (
            <div key={idx} style={{
              textAlign: "center",
              padding: "2rem",
            }}>
              <h3 style={{
                fontSize: "3rem",
                fontWeight: "700",
                marginBottom: "0.5rem",
                color: "#ff0000",
              }}>{stat.number}</h3>
              <p style={{
                fontSize: "1rem",
                textTransform: "uppercase",
                letterSpacing: "1px",
                color: textTertiary,
              }}>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section style={{
        padding: "6rem 2rem",
        backgroundColor: bgSecondary,
      }}>
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <div data-aos="fade-right" style={{ maxWidth: "900px" }}>
            <span style={{
              color: "#ff0000",
              fontSize: "0.9rem",
              fontWeight: "600",
              letterSpacing: "2px",
              textTransform: "uppercase",
              marginBottom: "1rem",
              display: "block",
            }}>WHO WE ARE</span>
            <h2 style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              marginBottom: "2rem",
              color: textPrimary,
            }}>Professional Artist Management</h2>
            <p style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              marginBottom: "1.5rem",
              color: textSecondary,
            }}>
              Faxon Entertainment is a premier artist management agency based in South Africa. 
              Founded by Kagiso Mabule, we are dedicated to discovering and nurturing exceptional 
              talent in AmaPiano, Hip Hop, and RnB.
            </p>
            <p style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              marginBottom: "1.5rem",
              color: textSecondary,
            }}>
              Our expertise focuses on the world-renowned AmaPiano genre and Hip Hop, speaking to 
              our niche market as an agency. We provide comprehensive management services including 
              branding, tour coordination, career development, and strategic partnerships.
            </p>
            <Link to="/about" style={{
              display: "inline-block",
              marginTop: "1rem",
              color: "#ff0000",
              fontSize: "1rem",
              fontWeight: "600",
              textDecoration: "none",
              transition: "all 0.3s ease",
            }}>
              Learn More About Us →
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURED ARTISTS SECTION */}
      <section style={{
        padding: "6rem 2rem",
        backgroundColor: bgPrimary,
      }}>
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          <div data-aos="fade-up" style={{
            textAlign: "center",
            marginBottom: "4rem",
          }}>
            <span style={{
              color: "#ff0000",
              fontSize: "0.9rem",
              fontWeight: "600",
              letterSpacing: "2px",
              textTransform: "uppercase",
              marginBottom: "1rem",
              display: "block",
            }}>OUR ROSTER</span>
            <h2 style={{
              fontSize: "2.5rem",
              fontWeight: "700",
              marginBottom: "2rem",
              color: textPrimary,
            }}>Featured Artists</h2>
            <p style={{
              fontSize: "1.1rem",
              maxWidth: "600px",
              margin: "1rem auto 0",
              color: textTertiary,
            }}>
              Discover the exceptional artists we represent in AmaPiano, Hip Hop, and RnB
            </p>
          </div>
          <div data-aos="fade-up" data-aos-delay="200" style={{
            maxWidth: "1400px",
            margin: "0 auto",
          }}>
            <Slider {...sliderSettings}>
              {featuredArtists.map((artist, i) => (
                <div key={i} style={{ padding: "0 1rem" }}>
                  <TalentCard {...artist} darkTheme={darkTheme} />
                </div>
              ))}
            </Slider>
          </div>
          <div style={{ textAlign: "center", marginTop: "3rem" }}>
            <Link to="/artists" style={{
              display: "inline-block",
              padding: "1rem 2.5rem",
              backgroundColor: "#ff0000",
              color: "#fff",
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "1rem",
              letterSpacing: "1px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(255, 0, 0, 0.4)",
            }}>
              View All Artists
            </Link>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section style={{
        padding: "6rem 2rem", 
        backgroundColor: "#ff0000",
        textAlign: "center",
      }} data-aos="fade-up">
        <div style={{ 
          maxWidth: "800px",
          margin: "0 auto",
        }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "1.5rem",
            color: "#fff",
          }}>Ready to Elevate Your Music Career?</h2>
          <p style={{
            fontSize: "1.2rem",
            lineHeight: "1.8",
            color: "#fff",
            marginBottom: "2.5rem",
            opacity: 0.95,
          }}>
            Join Faxon Entertainment and take your talent to the next level with
            professional artist management and global opportunities.
          </p>
          <Link to="/contact" style={{
            display: "inline-block",
            padding: "1.2rem 3rem",
            backgroundColor: "#fff",
            color: "#ff0000",
            borderRadius: "50px",
            textDecoration: "none",
            fontWeight: "700",
            fontSize: "1.1rem",
            letterSpacing: "1px",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
          }}>
            Get Started Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;